import React,{useState,useEffect} from 'react'
import {useGetDispatchAllDocumentsQuery,useGetDeliveryAllDocumentsQuery} from "./ProcurementApiSlice";
import { Table } from 'react-bootstrap';
export const AdminAllDoc = ({procList}) => {
    let procCode=procList.ProcCode
    const { data: AddResponse} = useGetDispatchAllDocumentsQuery(procCode,{skip:!procCode});
    const { data: AddResponseDelivery} = useGetDeliveryAllDocumentsQuery(procCode,{skip:!procCode});

    const[dispatchData,setDispatchRecords]=useState([])
    const[deliveryData,setdelivery]=useState([])
    const [updatedListBuyer, setUpdatedList] = useState([]);

    useEffect(() => {
        if (AddResponse!==undefined) {
          setDispatchRecords(AddResponse?.data);
        }
        if (AddResponseDelivery!==undefined) {
            setdelivery(AddResponseDelivery?.data);
          }
          const updatedList = procList?.all_media?.filter(
            (item) =>item.pattern === "Payment Sheet"
          );
          setUpdatedList(updatedList);
      }, [AddResponse,AddResponseDelivery]);
  return (
 
    <div>
{updatedListBuyer?.length>0?
  <div >
    <h4>Payment Sheet</h4>
    <Table border="1" striped hover style={{ width: '100%', marginTop: '10px' }}>
      <thead>
        <tr>
          <th>Created By</th>
          <th>Document Type</th>
          <th>View Document</th>
        </tr>
      </thead>
      <tbody>
  {procList?.all_media?.map((record) => {
   
    if(record.pattern === "Payment Sheet"){
    return (
      <tr>
        <td>{record.entity_type}</td>
        <td>{record.pattern}</td>
        <td>
          <a
            href={record.file}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Document
          </a>
        </td>
      </tr>
    )
  
  }
  })}
</tbody>

    </Table>
  </div>
  :""}

     {dispatchData?.map((dispatch) => (
  <div key={dispatch.id}>
    <h4>Dispatch Records</h4>
    <Table border="1" striped hover style={{ width: '100%', marginTop: '10px' }}>
      <thead>
        <tr>
          <th>Quantity</th>
          <th>Stock Location</th>
          <th>Document Type</th>
          <th>View Document</th>
        </tr>
      </thead>
      <tbody>
        {dispatch?.dispatch_records?.map((record) => {
          const documentsLength = record.documents.length;
          return record.documents.map((document, index) => (
            <tr key={document.id}>
              {index === 0 && (
                <td rowSpan={documentsLength}>{record.quantity} {procList?.unit_of_measure}</td>
              )}
            <td>{record?.stock_location?.address},{record?.stock_location?.district}</td>
            <td>{document.pattern}</td>
              <td>
                <a
                  href={document.file}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Document
                </a>
              </td>
            </tr>
          ));
        })}
      </tbody>
    </Table>
  </div>
))}

    
 {deliveryData?.map((dispatch) => (
  <div key={dispatch.id}>
    <h4>Delivery Records</h4>
    <Table border="1" striped hover style={{ width: '100%', marginTop: '10px' }}>
      <thead>
        <tr>
        <th>Quantity</th>
        <th>Document Type</th>
        <th>View Document</th>
        </tr>
      </thead>
      <tbody>
        {dispatch?.delivery_details?.map((record) => {
          const documentsLength = record.documents.length;
          return record.documents.map((document, index) => (
            <tr key={document.id}>
              {index === 0 && (
                <td rowSpan={documentsLength}>{record.quantity} {procList?.unit_of_measure}</td>
              )}
              <td>{document.pattern}</td>
              <td>
                <a
                  href={document.file}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Document
                </a>
              </td>
            </tr>
          ));
        })}
      </tbody>
    </Table>
  </div>
))}

    </div>


  )
}
